export const NO_ACTIVE_CONTRACT = 'No active contract';

/** Interval (ms) for proactive token-bridge refresh. Used by useAuth(alwaysFresh = true). */
export const PROACTIVE_REFRESH_INTERVAL_MS = 60_000;
